import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    submit: {
        margin: theme.spacing(3, 0, 2),
    }
}));